import OrganizationDetailModel from "../../services/models/API/responseModels/organizationDetailResponse.model";
import CustomText from "../atomic/CustomText";
import CustomImage from "../global/CustomImage";

function OrganizationCell({ cell, row }: { cell: any; row: any }): JSX.Element {
  const organization: OrganizationDetailModel =
    row?.original?.organization ?? null;

  return (
    <div className="flex items-center min-w-[140px]">
      {!!organization?.logoUrl && (
        <CustomImage
          src={organization?.logoUrl}
          alt={""}
          className="w-[27px] h-[16px] mr-1"
        />
      )}
      <CustomText text={organization.name} fontWeight="font-normal" />
    </div>
  );
}

export default OrganizationCell;
